export const removeImage = (images, index) => {
  // only allow removing all but one image
  if (images.length > 1) {
    let nextImages = images.slice(0)
    nextImages.splice(index, 1)
    return nextImages
  }
  return false
}
